import type { IAlfaSuggestionCity, IDadataSuggestionCity } from './types'

export const isCitySuggestionFormAlfa = (citySuggestion: unknown): citySuggestion is IAlfaSuggestionCity => {
  return (citySuggestion as IAlfaSuggestionCity)?.name !== undefined
}

export const isCitySuggestionFormDadata = (citySuggestion: unknown): citySuggestion is IDadataSuggestionCity => {
  return (citySuggestion as IDadataSuggestionCity)?.city !== undefined
}
